<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ix"><span class="txit">To librarians everywhere, including my husband. Without you, I couldn’t have done my research for this back in the early ’90s. Thank heaven for interlibrary loan!</span></a><a id="page_x"></a></p><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8cc03058